import { SUGGESTED_USER_CONNECTION } from '../constants';
import { addActionsToConnection } from '../utils/belay_helpers';

export const POPULATE_USERS = 'POPULATE_USERS';
export const DISMISS_USER = 'DISMISS_USER';

export const dismissUser = idx => {
  return { type: DISMISS_USER, payload: idx };
};

export const populateSuggestedUserConnections = suggestions => {
  return (dispatch, getState) => {
    const loadedUserConnections = new Set(getState().suggestedUserConnections.userConnections.map(s => s.user.id));
    const newSuggestions = suggestions
      .filter(s => !loadedUserConnections.has(s.user.id))
      .map(s => ({ ...addActionsToConnection(s), type: SUGGESTED_USER_CONNECTION }));

    dispatch({ type: POPULATE_USERS, payload: newSuggestions });
  };
};

export const initialSuggestedUserConnectionsState = {
  userConnections: []
};

export default function suggestedUserConnections(state = initialSuggestedUserConnectionsState, action) {
  switch (action.type) {
    case DISMISS_USER:
      return {
        ...state,
        userConnections: state.userConnections.filter((_, idx) => {
          return idx !== action.payload;
        })
      };
    case POPULATE_USERS:
      return {
        ...state,
        userConnections: action.payload
      };
    default:
      return state;
  }
}
